module.exports = __webpack_public_path__ + "img/02.0a8143a7.png";